import React from 'react';
import styled from 'styled-components';

const StyledLink = styled.a`
    opacity: 1;
    transition: opacity 0.3s ease;

    svg {
        fill: currentColor;
        stroke: inherit;
        color: ${props => props.color || '#0dbdfc'};
    }

    & + & {
        margin-left: 2.3rem;
    }

    &:hover {
        opacity: 0.7;
    }
`;

export const FbIcon = props => {
    return (
        <svg
            height="24"
            color={props.color}
            width="24"
            viewBox="0 0 6.35 6.35"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
        >
            <g transform="translate(232.98 -80.736)">
                <g transform="matrix(.26458 0 0 .26458 -232.98 80.736)">
                    <path d="m21.429 0h-18.857c-0.68199 0-1.336 0.27092-1.8183 0.75315s-0.75315 1.1363-0.75315 1.8183v18.857c0 0.682 0.27092 1.336 0.75315 1.8182 0.48224 0.4823 1.1363 0.7532 1.8183 0.7532h7.3527v-8.1595h-3.375v-3.8405h3.375v-2.9271c0-3.3295 1.9822-5.1686 5.018-5.1686 1.454 0 2.9743 0.25928 2.9743 0.25928v3.2679h-1.6751c-1.6506 0-2.1654 1.0243-2.1654 2.0748v2.4938h3.6846l-0.5893 3.8405h-3.0953v8.1595h7.3527c0.682 0 1.336-0.2709 1.8182-0.7532 0.4823-0.4822 0.7532-1.1362 0.7532-1.8182v-18.857c0-0.68199-0.2709-1.336-0.7532-1.8183-0.4822-0.48224-1.1362-0.75315-1.8182-0.75315z" />
                </g>
            </g>
        </svg>
    );
};

export const YtIcon = props => {
    return (
        <svg
            height="22"
            color={props.color}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="32"
            viewBox="0 0 32 22.4"
        >
            <path d="m31.331 3.5048c-0.368-1.3796-1.4523-2.4661-2.8291-2.8348-2.4955-0.67002-12.502-0.67002-12.502-0.67002s-10.007 0-12.502 0.67002c-1.3768 0.36878-2.4611 1.4552-2.8291 2.8348-0.66867 2.5006-0.66867 7.7178-0.66867 7.7178s0 5.2172 0.66867 7.7178c0.36803 1.3796 1.4524 2.4208 2.8291 2.7895 2.4956 0.67 12.502 0.67 12.502 0.67s10.007 0 12.502-0.67c1.3768-0.3687 2.4611-1.4099 2.8291-2.7895 0.6687-2.5006 0.6687-7.7178 0.6687-7.7178s0-5.2172-0.6687-7.7178zm-18.604 12.455v-9.4737l8.3636 4.737z" />
        </svg>
    );
};

export const VkIcon = props => {
    return (
        <svg
            height="20"
            color={props.color}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="32"
            viewBox="0 0 32 20"
        >
            <path d="M31.2707 1.68899C31.4905 0.946427 31.2707 0.399902 30.2133 0.399902H26.7143C25.8233 0.399902 25.4134 0.8692 25.1936 1.39196C25.1936 1.39196 23.4114 5.73446 20.8927 8.55024C20.0788 9.36409 19.7046 9.62547 19.259 9.62547C19.0392 9.62547 18.7006 9.36409 18.7006 8.62153V1.68899C18.7006 0.797914 18.4511 0.399902 17.7145 0.399902H12.2136C11.6552 0.399902 11.3226 0.815736 11.3226 1.20187C11.3226 2.04542 12.5819 2.24145 12.7126 4.61764V9.77398C12.7126 10.9027 12.5107 11.1106 12.0651 11.1106C10.877 11.1106 7.98995 6.75028 6.27909 1.76027C5.93454 0.791974 5.59593 0.399902 4.69892 0.399902H1.19998C0.201976 0.399902 0 0.8692 0 1.39196C0 2.31868 1.1881 6.92255 5.53059 13.0056C8.4236 17.158 12.4988 19.4094 16.2056 19.4094C18.4333 19.4094 18.7066 18.9104 18.7066 18.0491C18.7066 14.0808 18.5046 13.7066 19.6214 13.7066C20.1382 13.7066 21.0293 13.968 23.1085 15.9699C25.4847 18.3461 25.8767 19.4094 27.2074 19.4094H30.7064C31.7044 19.4094 32.2093 18.9104 31.9182 17.9243C31.2529 15.8511 26.7559 11.5858 26.554 11.3007C26.0371 10.6354 26.1856 10.3383 26.554 9.74428C26.5599 9.73834 30.8311 3.72657 31.2707 1.68899Z" />
        </svg>
    );
};

export function SocialButtons({ FbLink, YtLink, VkLink, fb, yt, vk, color }) {
    const socialData = [
        {
            isShow: fb,
            IconSvgComponent: FbIcon,
            link: FbLink || 'https://facebook.com/kesparu/',
        },
        {
            isShow: yt,
            IconSvgComponent: YtIcon,
            link:
                YtLink ||
                'https://youtube.com/channel/UC_yHk5QCg2y_kW1d_dZBCaw',
        },
        {
            isShow: vk,
            IconSvgComponent: VkIcon,
            link: VkLink || 'https://vk.com/',
        },
    ];
    return socialData.map(({ link, IconSvgComponent, isShow }) => {
        if (isShow) {
            return (
                <StyledLink
                    key={link}
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    color={color}
                >
                    <IconSvgComponent />
                </StyledLink>
            );
        } else {
            return null;
        }
    });
}
